import { FC } from "react";
import { ContainerProps, FlexDirection } from "../types";
import ContainerBase from "../container-base";

const Column: FC<ContainerProps> = (props) => {
  return (
    <ContainerBase
      {...props}
      flexDirection={
        props.reverse ? FlexDirection.ColumnReverse : FlexDirection.Column
      }
    >
      {props.children}
    </ContainerBase>
  );
};

export default Column;
